











import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import GeoMapLine from '@/components/organisms/GeoMap/GeoMapLine.vue';

@Component({
  name: 'GeoMapLineList',
  components: {
    GeoMapLine,
  },
})
export default class GeoMapLineList extends Vue {
  @Prop() public google: any;

  @Prop() public map: any;

  @Prop() protected polygonType!: any;

  @Prop() protected borders!: any;

  @Prop({ default: false }) protected autoZoom!: boolean;

  @Prop({ default: false }) protected autoCenter!: boolean;

  protected get bordersPrepared() {
    if (this.polygonType === 'MultiPolygon') {
      return this.borders.flat(1);
    }
    return this.borders;
  }

  @Watch('borders', { immediate: true, deep: true })
  protected onChangeBorders() {
    if (this.autoZoom) {
      this.updateAutoZoom();
    }
    if (this.autoCenter) {
      this.updateAutoCenter();
    }
  }

  protected getPathsPrepared = (path: any) => {
    if (!path) {
      return [];
    }
    return path
      .filter((item: any) => Array.isArray(item) && item.length === 2)
      .map(([lng, lat]: any) => ({ lng, lat }));
  };

  protected getBounds() {
    const bounds: any = new this.google.maps.LatLngBounds();
    this.bordersPrepared.forEach((paths: any) => {
      const pathsPrepared: any = this.getPathsPrepared(paths);
      pathsPrepared.forEach((path: any) => {
        const loc = new this.google.maps.LatLng(path.lat, path.lng);
        bounds.extend(loc);
      });
    });
    return bounds;
  }

  protected updateAutoZoom() {
    this.map.fitBounds(this.getBounds());
  }

  protected updateAutoCenter() {
    this.map.panToBounds(this.getBounds());
  }
}
